
const BetLogCasino = () => {
  return(<div>Casino</div>)
}
export default BetLogCasino;